"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SubstanceNucleicAcid_Subunit = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_integer_1 = require("../Scalar/RTTI_integer");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Attachment_1 = require("./RTTI_Attachment");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_SubstanceNucleicAcid_Linkage_1 = require("./RTTI_SubstanceNucleicAcid_Linkage");
var RTTI_SubstanceNucleicAcid_Sugar_1 = require("./RTTI_SubstanceNucleicAcid_Sugar");
exports.RTTI_SubstanceNucleicAcid_Subunit = t.recursion('ISubstanceNucleicAcid_Subunit', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        subunit: RTTI_integer_1.RTTI_integer,
        _subunit: RTTI_Element_1.RTTI_Element,
        sequence: t.string,
        _sequence: RTTI_Element_1.RTTI_Element,
        length: RTTI_integer_1.RTTI_integer,
        _length: RTTI_Element_1.RTTI_Element,
        sequenceAttachment: RTTI_Attachment_1.RTTI_Attachment,
        fivePrime: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        threePrime: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        linkage: t.array(RTTI_SubstanceNucleicAcid_Linkage_1.RTTI_SubstanceNucleicAcid_Linkage),
        sugar: t.array(RTTI_SubstanceNucleicAcid_Sugar_1.RTTI_SubstanceNucleicAcid_Sugar)
    });
});
//# sourceMappingURL=RTTI_SubstanceNucleicAcid_Subunit.js.map